import { Node } from "@tiptap/vue-2";

export const ImageUpload = Node.create({
    name: "image",
    group: "inline",
    inline: true,
    draggable: true,

    addAttributes() {
        return {
            src: {
                default: "",
            },
            alt: {
                default: "Ảnh minh hoạ",
            },
            id: {
                default: "",
            },
            width: {
                default: "100%",
            },
            alignment: {
                default: "center",
            }
        };
    },

    parseHTML() {
        return [{
            tag: "img[src]",
            getAttrs: dom => ({
                src: dom.getAttribute('src'),
                alt: dom.getAttribute('alt'),
                id: dom.getAttribute('id'),
                width: dom.style.width || dom.getAttribute('width') || '100%',
                alignment: dom.style.marginLeft === '0px' && dom.style.marginRight === 'auto' ? 'left' :
                           dom.style.marginLeft === 'auto' && dom.style.marginRight === '0px' ? 'right' : 'center'
            })
        }];
    },

    renderHTML({ HTMLAttributes }) {
        const attrs = { ...HTMLAttributes };
        delete attrs.style;
        let styleStr = `width: ${HTMLAttributes.width || '100%'};`;
        if (HTMLAttributes.alignment === 'left') {
            styleStr += 'margin-right: auto; margin-left: 0; display: block;';
        } else if (HTMLAttributes.alignment === 'right') {
            styleStr += 'margin-left: auto; margin-right: 0; display: block;';
        } else {
            styleStr += 'margin-left: auto; margin-right: auto; display: block;';
        }
        return ["img", { ...attrs, style: styleStr }];
    },

    addCommands() {
        return {
            setImage:
                (options) =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                            attrs: options,
                        });
                    },
        };
    },

    addNodeView() {
        return ({ node, getPos, editor }) => {
            const container = document.createElement("div");
            container.className = "image-node-container";
            
            updateContainerStyle(container, node.attrs.width, node.attrs.alignment);

            const img = document.createElement("img");
            img.src = node.attrs.src;
            img.alt = node.attrs.alt || "";
            img.id = node.attrs.id;
            img.style.width = "100%";
            img.style.display = "block";
            img.style.cursor = "pointer";

            container.appendChild(img);

            // Create Overlay Toolbar
            const toolbar = document.createElement("div");
            toolbar.className = "image-toolbar";
            toolbar.style.display = "none";
            
            // Width choices
            const widths = ["25%", "50%", "75%", "100%"];
            widths.forEach(w => {
                const btn = document.createElement("button");
                btn.type = "button";
                btn.innerText = w;
                btn.className = "image-toolbar-btn";
                if (node.attrs.width === w) btn.classList.add("is-active");
                btn.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (typeof getPos === 'function') {
                        editor.view.dispatch(
                            editor.view.state.tr.setNodeMarkup(getPos(), undefined, {
                                ...node.attrs,
                                width: w
                            })
                        );
                    }
                });
                toolbar.appendChild(btn);
            });

            // Separator
            const sep = document.createElement("span");
            sep.className = "image-toolbar-separator";
            toolbar.appendChild(sep);

            // Alignment choices
            const aligns = [
                { value: "left", label: "Căn trái" },
                { value: "center", label: "Căn giữa" },
                { value: "right", label: "Căn phải" }
            ];
            aligns.forEach(a => {
                const btn = document.createElement("button");
                btn.type = "button";
                btn.innerText = a.label;
                btn.className = "image-toolbar-btn";
                if (node.attrs.alignment === a.value) btn.classList.add("is-active");
                btn.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (typeof getPos === 'function') {
                        editor.view.dispatch(
                            editor.view.state.tr.setNodeMarkup(getPos(), undefined, {
                                ...node.attrs,
                                alignment: a.value
                            })
                        );
                    }
                });
                toolbar.appendChild(btn);
            });

            // Separator 2
            const sep2 = document.createElement("span");
            sep2.className = "image-toolbar-separator";
            toolbar.appendChild(sep2);

            // Delete choice
            const delBtn = document.createElement("button");
            delBtn.type = "button";
            delBtn.innerText = "Xóa ảnh";
            delBtn.className = "image-toolbar-btn delete-btn";
            delBtn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (typeof getPos === 'function') {
                    editor.view.dispatch(
                        editor.view.state.tr.delete(getPos(), getPos() + 1)
                    );
                }
            });
            toolbar.appendChild(delBtn);

            container.appendChild(toolbar);

            // Toggle toolbar on image click
            img.addEventListener("click", (e) => {
                e.stopPropagation();
                document.querySelectorAll(".image-toolbar").forEach(tb => {
                    if (tb !== toolbar) tb.style.display = "none";
                });
                toolbar.style.display = toolbar.style.display === "flex" ? "none" : "flex";
            });

            // Hide toolbar on click outside
            const clickOutsideHandler = () => {
                toolbar.style.display = "none";
            };
            document.addEventListener("click", clickOutsideHandler);

            function updateContainerStyle(dom, width, alignment) {
                dom.style.width = width || "100%";
                dom.style.display = "block";
                
                if (alignment === 'left') {
                    dom.style.marginRight = "auto";
                    dom.style.marginLeft = "0";
                } else if (alignment === 'right') {
                    dom.style.marginLeft = "auto";
                    dom.style.marginRight = "0";
                } else {
                    dom.style.marginLeft = "auto";
                    dom.style.marginRight = "auto";
                }
            }

            return {
                dom: container,
                update: (updatedNode) => {
                    if (updatedNode.type !== node.type) {
                        return false;
                    }

                    if (updatedNode.attrs.src !== img.src) {
                        img.src = updatedNode.attrs.src;
                    }

                    updateContainerStyle(container, updatedNode.attrs.width, updatedNode.attrs.alignment);

                    const buttons = toolbar.querySelectorAll(".image-toolbar-btn");
                    let btnIdx = 0;
                    widths.forEach(w => {
                        const btn = buttons[btnIdx++];
                        if (btn) {
                            if (updatedNode.attrs.width === w) btn.classList.add("is-active");
                            else btn.classList.remove("is-active");
                        }
                    });
                    
                    btnIdx++; // Skip separator
                    
                    aligns.forEach(a => {
                        const btn = buttons[btnIdx++];
                        if (btn) {
                            if (updatedNode.attrs.alignment === a.value) btn.classList.add("is-active");
                            else btn.classList.remove("is-active");
                        }
                    });

                    return true;
                },
                destroy() {
                    document.removeEventListener("click", clickOutsideHandler);
                }
            };
        };
    },
})